import { a } from './chunk-XCSSTYD2.mjs';
import { create } from 'zustand';
import o from 'react';

var s=create((e,n)=>({...a(e,n),canHide:!0,hide:()=>{let{isActive:t,canHide:c}=n();t&&c&&e({isActive:!1});},setCanHide(t){e({canHide:t});}}));var r=o.createContext({}),C={signInStrategy:"complete"};function m(){let e=o.useContext(r);return o.useMemo(()=>({...C,...e}),[e])}

export { s as a, r as b, m as c };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-O62ADXEQ.mjs.map